import React, {
  CSSProperties,
  FC,
  PropsWithChildren,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';

import { CSSTransition } from 'react-transition-group';

import questionImage from '../../../../assets/images/svg/question.svg';
import { Image } from '../../images';

import './Information.scoped.scss';

// сколько оставлять от подсказки до края экрана, px
const SCREEN_GAP = 8;

interface Props {
  className?: string;
  position?: 'top' | 'bottom' | 'left';
}

const Information: FC<PropsWithChildren<Props>> = (props) => {
  const { children, className, position = 'top' } = props;

  const [active, setActive] = useState(false);
  const timeoutRef = useRef(0);

  // Подсказка открывается относительно значка и у края экрана вылезала за него.
  // При показе сдвигаем её ровно настолько, чтобы она осталась в пределах окна;
  // стрелка сдвигается обратно и продолжает указывать на значок.
  const answerRef = useRef<HTMLDivElement>(null);
  const [shift, setShift] = useState(0);

  useLayoutEffect(() => {
    const answer = answerRef.current;
    if (!active || !answer) return;
    const rect = answer.getBoundingClientRect();
    const left = rect.left - shift;
    const right = rect.right - shift;
    const viewportWidth = document.documentElement.clientWidth;
    let nextShift = 0;
    if (right > viewportWidth - SCREEN_GAP) nextShift = viewportWidth - SCREEN_GAP - right;
    if (left + nextShift < SCREEN_GAP) nextShift = SCREEN_GAP - left;
    if (nextShift !== shift) setShift(Math.round(nextShift));
  }, [active, shift]);

  const onHover = () => {
    clearTimeout(timeoutRef.current);
    setActive(true);
  };

  const onLeave = () => {
    timeoutRef.current = window.setTimeout(() => {
      setActive(false);
    }, 250);
  };

  const getClassNames = () => {
    let styles = ['information__answer'];
    if (position === 'bottom') styles.push('information__position_bottom');
    if (position === 'left') styles.push('information__position_left');
    if (className) styles.push(className);
    return styles.join(' ');
  };

  return (
    <div className="information" onMouseEnter={onHover} onMouseLeave={onLeave}>
      <Image src={questionImage} />
      <CSSTransition in={active} timeout={250} classNames="information__answer-">
        <div
          ref={answerRef}
          className={getClassNames()}
          style={{ marginLeft: shift, '--information-shift': `${shift}px` } as CSSProperties}
        >
          <div className="information__text">{children}</div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default Information;
